<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :onLoaded="mapResults"
            :actions="actions"
            :hideHeaderFilter="true"
            ref="grid"
        ></dx-grid>
        <v-dialog v-model="imageViewDialog" max-width="800">
            <v-card>
                <div v-for="image in clickedRow.images">
                    <v-img :src="image"></v-img>
                </div>
            </v-card>
        </v-dialog></div
></template>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../utils/helpers.js";
import * as firebase from "firebase/app";
import "firebase/database";

export default {
    data: () => ({
        title: "All Messages",

        imageViewDialog: false,
        clickedRow: "",

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "mdi-message-text";
                        case "PENDING":
                            return "mdi-message-processing";
                        case "SENT":
                            return "mdi-comment-arrow-right";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "COMPLETED":
                        case "SENT":
                            return "success";
                        case "PENDING":
                            return "#fdb400";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Account ID",
                field: "accountID",
                template: "link-action-cell-template",
                format: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameH",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "dateTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(3, "day")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Attachment",
                field: "attachment",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return row.attachmentUrls;
                },
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "username",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Message Type",
                field: "messageType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        selectedCallbacks: [],
        url: "",
        assignCallDialog: false,
        user: "",
        processing: false,
        action: "",
    }),
    created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onAccountIDClick;

        this.columns.find((c) => c.field == "attachment").linkAction = (
            message,
        ) => {
            const clickedRow = message;

            clickedRow.images = clickedRow.attachmentUrls.split(";");

            this.clickedRow = clickedRow;

            this.imageViewDialog = true;
        };

        this.user = this.$store.state.authentication.user;
    },
    mounted() {
        // if (this.$refs && this.$refs.grid) {
        //     this.firebaseSetup();
        // }
    },
    methods: {
        async beforeSetupGrid() {
            this.columns.find(
                (c) => c.field == "accountID",
            ).linkAction = this.onAccountIDClick;

            this.url = "communications?type=SMS&status=&user=";
        },
        onAccountIDClick(row) {
            this.onRowClicked(row);
        },
        async onRowClicked(row) {
            if (!row.accountID.startsWith("CallerID")) {
                this.$router.push({
                    name: "Account View",
                    params: {
                        id: row.accountID,
                    },
                    query: {
                        goToMessageSection: true,
                    },
                });

                return;
            }
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value.substring(1));
        },
        mapResults(results) {
            return results.map((sms) => {
                sms.attachment = sms.attachmentUrls ? "Attachment" : "";

                return sms;
            });
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("navigation");

            const query = ref
                .orderByChild("Name")
                .equalTo("CallbackRequest")
                .limitToLast(1);

            query.on(
                "value",
                (snapshot) => {
                    this.$refs.grid.reloadGrid();
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
    },
};
</script>
